<template>
  <div :class="`introductionItem introduction-${slide.style}`">
    <div class="introductionItem__text">
      <div class="accelerate-sales-banner__inner">
        <p
          :style="titleStyle"
          v-if="has_title"
          v-html="slide.title"
          class="title introductionItem__title"/>
        <p
          v-if="has_description"
          v-html="slide.description"
          class="introductionItem__description"/>
        <slot :name="slide.button"></slot>
      </div>
    </div>
    <div
      v-if="has_thumb"
      :class="[slide.classname, {'introductionItem__thumb--gradient': has_gradient, 'cian-introduction__img': lang === 'ru'}]"
      :style="{
        'background-image': 'url(' + require(`@/assets/img/${slide.thumb}`) + ')',
        'width': slide.button === 'intro5' ? '570px' : ''
      }"
      class="introductionItem__thumb"/>
  </div>
</template>

<script>
export default {
  name: 'IntroductionItem',
  props: {
    slide: {
      type: Object,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
  },
  computed: {
    has_description() {
      return !!this.slide.description;
    },
    has_gradient() {
      return !!this.slide.gradient;
    },
    has_thumb() {
      return !!this.slide.thumb;
    },
    has_title() {
      return !!this.slide.title;
    },
    titleStyle() {
      return {
        fontWeight: this.lang === 'ru' ?? 800,
      };
    },
  },
};
</script>
